const state = {}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/raceResume/state.js